import { CampaignAnalyticsReport } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { theme } from '@features/executive-report/domain/theme';
import { Table, TableRow } from '@features/powerpoint';
import {
  INDEX_WIDTH,
  NORMAL_WIDTH,
  ROWS_PER_TABLE,
  headersToTableRow,
  defaultTableOptions,
  STATE_WIDTH,
  cellOptionsByIndex,
  VISIT_INDEX_WIDTH,
} from './table-utils';
import { sortBy } from '@utils/arrays';
import { MetaTableStyle } from '@features/executive-report/domain/meta-table-style';

const CELL_FONT_SIZE_SMALL = 8;

const cityStateZipRegex = (city: string, state: string) =>
  new RegExp(`${city} ${state} [0-9]+$`);

const headers = ['', 'Location', 'Address', 'City', 'State', 'Visit Index'].map(
  header => header.toUpperCase()
);

export const brandLocationsTable = (
  brandLocationVisits: CampaignAnalyticsReport['brandLocationVisits'],
  metaTableStyle?: MetaTableStyle
): Table => {
  const topLocationsRows: TableRow[] = brandLocationVisits.data
    .toSorted(sortBy('index', 'desc'))
    .slice(0, ROWS_PER_TABLE)
    .map((brandLocationVisit, index): TableRow => {
      const options = cellOptionsByIndex(
        index,
        Math.min(brandLocationVisits.data.length, ROWS_PER_TABLE),
        metaTableStyle
      );

      return [
        {
          text: (index + 1).toString(),
          options: {
            ...options,
            color: metaTableStyle?.cellFontColor ?? theme.colors.lightBlue,
            align: 'center',
          },
        },
        {
          text: brandLocationVisit.name,
          options: {
            ...options,
            bold: true,
          },
        },
        {
          text: brandLocationVisit.address.replace(
            cityStateZipRegex(
              brandLocationVisit.city,
              brandLocationVisit.state
            ),
            ''
          ),
          options: {
            ...options,
            fontSize: CELL_FONT_SIZE_SMALL,
          },
        },
        {
          text: brandLocationVisit.city,
          options: {
            ...options,
            fontSize: CELL_FONT_SIZE_SMALL,
          },
        },
        {
          text: brandLocationVisit.state,
          options: {
            ...options,
            fontSize: CELL_FONT_SIZE_SMALL,
          },
        },
        {
          text: brandLocationVisit.index.toString(),
          options: {
            ...options,
            align: 'center',
          },
        },
      ];
    });

  return {
    tableRows: [
      headersToTableRow(headers, undefined, metaTableStyle),
      ...topLocationsRows,
    ],
    options: {
      ...defaultTableOptions,
      color: metaTableStyle?.cellFontColor ?? defaultTableOptions.color,
      w: 5.85,
      x: 6.99,
      colW: [
        INDEX_WIDTH,
        NORMAL_WIDTH,
        NORMAL_WIDTH,
        NORMAL_WIDTH,
        STATE_WIDTH,
        VISIT_INDEX_WIDTH,
      ],
    },
  };
};
